/* Automatically generated file, do not update manually */
    export const abi = [{"name":"balances","type":"function","stateMutability":"view","inputs":[{"type":"address","name":"addr"}],"outputs":[{"type":"uint256"}]}] as const;
    